export const Email = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="email (3) 1">
      <path
        id="Vector"
        d="M15.1729 15.9288C14.526 16.3601 13.7747 16.588 13 16.588C12.2254 16.588 11.474 16.3601 10.8272 15.9288L0.173113 8.82591C0.114004 8.78651 0.056418 8.74543 0 8.70318V20.3421C0 21.6765 1.08291 22.7356 2.39347 22.7356H23.6065C24.9409 22.7356 25.9999 21.6526 25.9999 20.3421V8.70312C25.9434 8.74548 25.8857 8.78666 25.8265 8.82612L15.1729 15.9288Z"
        fill="#80b73f"
      />
      <path
        id="Vector_2"
        d="M1.01816 7.55741L11.6722 14.6604C12.0755 14.9293 12.5377 15.0637 12.9999 15.0637C13.4622 15.0637 13.9245 14.9292 14.3278 14.6604L24.9818 7.55741C25.6194 7.13262 26 6.42168 26 5.65438C26 4.33503 24.9266 3.26172 23.6073 3.26172H2.39266C1.07336 3.26177 0 4.33508 0 5.65565C0 6.42168 0.380656 7.13262 1.01816 7.55741Z"
        fill="#80b73f"
      />
    </g>
  </svg>
);
